import { convertISOToPicker } from '@core/js/components/common/Fields/DatePicker';
import { confirm, func } from '@core/js/utils/Validation/validationRules';
import {
    DATE_FIELD_DISPLAY_TYPE,
    FORM_FIELD_TYPE
} from '@core/js/components/common/Form/constants';
import {
    TValidationMethodConfig,
    IValidationMethodConfigConfirm
} from '@core/js/utils/Validation/types';
import {
    TFormField
} from '@core/js/components/common/Form/types';

import { checkIfUsernameIsAvailable } from '@theme/js/hooks/usePublicAPI/hooks/useServerPublicAPI/server';
import { PHONE_PREFIX } from '@theme/js/components/main/SmsVerification/constants';

import {
    isValidDateString, cmsDateStringToDate, getCountriesList,
    getCurrenciesList, getPhoneAreaCodeList, imsToFieldValue, imsToPhoneFieldValue,
    fieldToImsValue, getExtraImsFields, getRangeFromValidation, validationRulesToValidationMethods, getFormFields,
    getFormRules, getHiddenByRulesFields, getLimitActions
} from '@core/js/components/common/ChangeForm/helpers';

export {
    isValidDateString, cmsDateStringToDate, getCountriesList,
    getCurrenciesList, getPhoneAreaCodeList, imsToFieldValue, imsToPhoneFieldValue,
    fieldToImsValue, getExtraImsFields, getRangeFromValidation, validationRulesToValidationMethods, getFormFields,
    getFormRules, getHiddenByRulesFields, getLimitActions
};

export const getFieldValidations = (field: TFormField, casinoName: string): Record<string, TValidationMethodConfig[]> => {
    const validations: Record<string, TValidationMethodConfig[]> = {};

    validations[field.name] = validationRulesToValidationMethods(field.validationRules, field.baseType);

    switch (field.type) {
        case FORM_FIELD_TYPE.TEXT:
        case FORM_FIELD_TYPE.EMAIL:
        case FORM_FIELD_TYPE.PASSWORD:
            if (field.requiresConfirmation) {
                validations[`${field.name}_confirmation`] = [
                    confirm({
                        field: field.name,
                        error: field.negativeTooltip
                    }) as IValidationMethodConfigConfirm
                ];
            }

            break;
        // region @theme
        case FORM_FIELD_TYPE.CELLPHONE: {
            validations[field.name].push(
                func({
                    fn: async (phone: string) => {
                        debugger;
                        try {
                            const res = await checkIfUsernameIsAvailable({ casinoName, phone: PHONE_PREFIX + phone });
                            if (res?.data?.phoneAvailable) {
                                return null;
                            }
                        } catch (e) {
                            console.warn(e);
                        }
                        return ['playtech.mobile.system.verification.changeNumber.validation.unique'];
                    }
                }) as TValidationMethodConfig<string>
            );
            break;
        }
        // endregion theme
        case FORM_FIELD_TYPE.DATE_PICKER:
        case FORM_FIELD_TYPE.DATE_OF_BIRTH:
        case FORM_FIELD_TYPE.DATE_OF_BIRTH_INNER: {
            validations[field.name].push(
                func({
                    fn: (value: string) => {
                        const { year: yearStr, month: monthStr, day: dayStr } = convertISOToPicker(value);
                        const [year, month, day] = [yearStr, monthStr, dayStr].map(part => parseInt(part));
                        const areAllInputsEmpty = [year, month, day].every(part => isNaN(part));
                        const areAllInputsFilled = [year, month, day].every(part => !isNaN(part));
                        const errorMessage = field.type === FORM_FIELD_TYPE.DATE_PICKER
                            ? 'playtech.mobile.system.form.datePicker.internal.required'
                            : 'playtech.mobile.system.form.birthdate.internal.required';

                        if (field.displayType === DATE_FIELD_DISPLAY_TYPE.INPUT) {
                            return isValidDateString(value) ? null : [errorMessage];
                        }

                        if (areAllInputsEmpty || areAllInputsFilled) {
                            return null;
                        }

                        return [errorMessage];
                    }
                }) as TValidationMethodConfig<string>
            );

            break;
        }
        case FORM_FIELD_TYPE.BET_LIMITS:
        case FORM_FIELD_TYPE.LOSS_LIMITS:
        case FORM_FIELD_TYPE.DEPOSIT_LIMITS:
            delete validations[field.name];
            break;
        default:
            break;
    }

    return validations;
};
